import { hasCapability, type User } from "../base";

export const ahj = {
  read: (user: User) => hasCapability(user, "ahj.read"),
};
